import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TextStyle } from 'spa/components/typography/text_style'
import classNames from 'classnames'
import cn from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles'

const ActionConfirm = ({
  onClose,
  primaryAction,
  secondaryAction,
  title = '',
  subtitle = '',
  primaryActionText,
  secondaryActionText,
  vertical = true,
}) => {
  return (
    <div className={classNames(styles.center, styles.questionTextWrapper)}>
      {onClose && (
        <FontAwesomeIcon
          className={cn(styles.closeButton, styles.onClose)}
          icon={['fal', 'times-circle']}
          onClick={onClose}
        />
      )}
      <div className={styles.header}>
        <TextStyle className={styles.headerTitle} uppercase>
          {title}
        </TextStyle>
        {subtitle && <TextStyle color="grey">{subtitle}</TextStyle>}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: vertical ? 'column' : 'row',
          gap: '8px',
          rowGap: '8px',
        }}
      >
        <button onClick={primaryAction}>{primaryActionText}</button>
        {secondaryAction && (
          <button className="secondary" onClick={secondaryAction}>
            {secondaryActionText}
          </button>
        )}
      </div>
    </div>
  )
}

ActionConfirm.propTypes = {
  onClose: PropTypes.func,
  primaryAction: PropTypes.func,
  primaryActionText: PropTypes.string,
  secondaryAction: PropTypes.func,
  secondaryActionText: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  vertical: PropTypes.bool,
}

export default ActionConfirm
